// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"menuIcon--2g1jV","menu":"menu--pLiZc"};